import ApiCall from "../../Apicall/ApiCall";

// What the seller states on the contract page, and the two confirmations, are kept on the contract
// so a party who comes back finds them as they left them. Each call saves one thing on its own; it
// answers true when the server took it. The live update to the other party is separate (SignalR).
export async function saveContractDetails(contractId, patch) {
  if (!contractId) return false;
  try {
    await ApiCall({
      url: "/ContractMain/SaveContractDetails",
      method: "POST",
      data: { id: Number(contractId), ...patch },
    });
    return true;
  } catch (err) {
    console.error("Could not save the contract details:", err);
    return false;
  }
}

export async function confirmBuyerInspection(contractId, confirmed) {
  if (!contractId) return false;
  try {
    await ApiCall({
      url: "/ContractMain/ConfirmBuyerInspection",
      method: "POST",
      data: { id: Number(contractId), confirmed: Boolean(confirmed) },
    });
    return true;
  } catch (err) {
    console.error("Could not save the buyer's confirmation:", err);
    return false;
  }
}
